/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
/**
 * Route configuration for Bills pages
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.20.1
 * @since 1.1.0
 */
import { PageBillsType } from '../../pages/PageBills/pageBillsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export interface IBillsRouteConfiguration extends IAppRouterConfiguration {
    type: PageBillsType;
}

export const BillsRouteConfiguration: IBillsRouteConfiguration[] = [
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.bills],
        path: RoutePath.bills,
        type: PageBillsType.BILLS,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.billsAccountId],
        path: RoutePath.billsAccount,
        type: PageBillsType.BILLS_ACCOUNT,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.billsUnpaid],
        path: RoutePath.billsUnpaid,
        type: PageBillsType.BILLS_UNPAID,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.billsUnpaidAccountId],
        path: RoutePath.billsUnpaidAccount,
        type: PageBillsType.BILLS_UNPAID_ACCOUNT,
    },
];
